module.exports = __webpack_public_path__ + "static/Amelie White-153b56352deee5b5940971aa37b0bbc7.png";